<div [ngClass]="active ? 'score-card-active' : 'score-card-inactive'" fxLayout="row" fxFlex>
  <div class="rank" fxFlex="20" fxLayoutAlign="center center">
    <p class="eon-heading">{{rank}}</p>
  </div>
  <div class="user" fxFlex="50" fxLayoutAlign="center center">
    {{userName}}
  </div>
  <div class="score" fxFlex="20" fxLayoutAlign="center center">
    {{score}}
  </div>
</div>
